import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Login from './pages/Login';
import PinsPage from './pages/PinsPage';
import Products from './pages/Products';
// import Customers from './components/Customers';
import TrendingPage from './pages/TrendingPage';
import IGScraperControl from './pages/IGScraperControl';
import PinterestPostingPage from './pages/PinterestPostingPage';
import ReelsPage from './pages/ReelsPage';
import OnboardPage from './pages/OnboardPage';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import RoleBasedRoute from './components/RoleBasedRoute';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <RoleBasedRoute>
                  <Layout>
                    <PinsPage />
                  </Layout>
                </RoleBasedRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/products"
            element={
              <ProtectedRoute>
                <RoleBasedRoute>
                  <Layout>
                    <Products />
                  </Layout>
                </RoleBasedRoute>
              </ProtectedRoute>
            }
          />

          <Route
            path="/trending"
            element={
              <ProtectedRoute>
                <RoleBasedRoute>
                  <Layout>
                    <TrendingPage />
                  </Layout>
                </RoleBasedRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/scraper"
            element={
              <ProtectedRoute>
                <RoleBasedRoute>
                  <Layout>
                    <IGScraperControl />
                  </Layout>
                </RoleBasedRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/pinterest"
            element={
              <ProtectedRoute>
                <RoleBasedRoute>
                  <Layout>
                    <PinterestPostingPage />
                  </Layout>
                </RoleBasedRoute>
              </ProtectedRoute>
            }
          />

          <Route
            path="/reels"
            element={
              <ProtectedRoute>
                <RoleBasedRoute>
                  <Layout>
                    <ReelsPage />
                  </Layout>
                </RoleBasedRoute>
              </ProtectedRoute>
            }
          />

          <Route path="/onboard" element={<OnboardPage />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
